<template>
    <va-edit-layout>
        <ShipmentEventShipmentItem-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItem-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
